import React, { memo } from 'react'
import { useStepItem, StepItemProps } from './useStepItem'
import styles from './StepItem.module.scss'

const StepItem: React.FC<StepItemProps> = (props: StepItemProps) => {
  const { number, title, description } = useStepItem(props)

  return (
    <div className={styles['step-item']}>
      <div className={styles['step-number']}>{number}</div>
      <div className={styles['step-content']}>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default memo(StepItem)
